<div class="db-upgrade-plan-item db-upgrade-plan-item_{{subscription.type === 'bundle' && subscription.plan.title === 'standard' ? 'special' : subscription.plan.title}}" >
  <div class="db-upgrade-plan-item__main-info">
    <div class="db-upgrade-plan-item_special_personal-top-badge" *ngIf="subscription.type === UserSubscriptionType.PREMIUM">Save <span>$735</span></div>
    <h4 class="db-upgrade-plan-item__title">{{subscription?.plan?.shortFeatures?.plan_type === 'special_offer' ? 'special offer' : subscription.plan.title}}</h4>
    <div class="db-upgrade-plan-item__price">
      <span><i class="db-icon db-icon-dollar"></i></span>
      <span>{{subscription?.plan?.price | DbNumberParseIntPipe}}</span>
    </div>

    <a *ngIf="subscription.firstPaymentDate === null" class="db-upgrade-plan-item__choose-button db-button db-button_xxl" (click)="chooseSubscription()"><span>buy now</span></a>
  </div>

  <div class="db-upgrade-plan-item__additional-info">
    <div class="db-upgrade-plan-item__special_feature-wrap" *ngIf="subscription.type === UserSubscriptionType.PREMIUM">
      <div class="db-upgrade-plan-item__special_feature_header">{{product.title}} premium</div>
      <div class="db-upgrade-plan-item__special_feature_body">
        <div class="db-upgrade-plan-item__special_feature-primary">
          <div>
            <div class="db-upgrade-plan-item__special_feature-plugins-count">{{pluginsCount}}</div>
            <div class="db-upgrade-plan-item__special_feature-title">premium plugins extensions</div>
          </div>
          <div class="db-upgrade-plan-item__special_feature_plugins" *ngIf="planDescription?.mainFeatures[0]">
            <div *ngFor="let plugin of planDescription?.mainFeatures[0].features">{{plugin.title}}<span>,</span></div>
          </div>
        </div>
        <div class="db-upgrade-plan-item__special_feature-primary" *ngIf="planDescription && planDescription.mainFeatures[1]">
          <div>
            <div class="db-upgrade-plan-item__special_feature-plugins-count">{{extensionCount}}</div>
            <div class="db-upgrade-plan-item__special_feature-title">Premium {{product.title}} extensions</div>
          </div>
          <div class="db-upgrade-plan-item__special_feature_plugins" *ngIf="planDescription?.mainFeatures[1]">
            <div *ngFor="let extension of planDescription?.mainFeatures[1].features">{{extension.title}}<span>,</span></div>
          </div>
        </div>
      </div>
      <div class="db-upgrade-plan-item__special_feature">
        <div><i class="db-icon db-icon-success"></i></div>
        <div>
          <div>
            <span><span>{{subscription?.plan?.periodNumber}} months</span> access to Updates</span>
          </div>
        </div>
      </div>
      <div class="db-upgrade-plan-item__special_feature">
        <div><i class="db-icon db-icon-success"></i></div>
        <div>
          <div>
            <span><span>{{subscription?.plan?.periodNumber}} months</span> premium Support</span>
          </div>
        </div>
      </div>
      <div class="db-upgrade-plan-item__special_feature">
        <div><i class="db-icon db-icon-success"></i></div>
        <div>
          <div>
            <span><span>{{subscription?.plan?.domainCount}} domains</span> Supported</span>
          </div>
        </div>
      </div>
    </div>
    <div class="db-upgrade-plan-item__subfeature">
      <div><span></span></div>

      <div>
        <div>
          <span><span>{{subscription?.plan?.periodNumber}} months</span> access to Updates</span>
        </div>
      </div>
    </div>
    <div class="db-upgrade-plan-item__subfeature">
      <div><span></span></div>

      <div>
        <div>
          <span><span>{{subscription?.plan?.periodNumber}} months</span> premium Support</span>
        </div>
      </div>
    </div>
    <div class="db-upgrade-plan-item__subfeature">
      <div><span></span></div>

      <div>
        <div>
          <span><span>{{subscription?.plan?.domainCount}} domains</span> Supported</span>
        </div>
      </div>
    </div>
    <div class="db-upgrade-plan-item__features">
      <div class="db-upgrade-plan-item__feature" *ngFor="let feature of planDescription.mainFeatures">
        <div *ngIf="feature">
          <i class="db-icon db-icon-success"></i>
        </div>

        <div *ngIf="feature">{{feature.title}}</div>
      </div>
    </div>


  </div>
</div>
